import { get } from './cms-content-api-service';
import { HelsenorgeHttpError } from './hn-proxy-service';
/**
 * Hjelpemetode for å sende get-requester til content-API sammen med createApi fra RTK
 * @param args
 * @returns
 */
export const getBaseQuery = async (args) => {
    try {
        const response = await get(...args);
        return { data: response };
    }
    catch (error) {
        if (error instanceof HelsenorgeHttpError) {
            return {
                error: {
                    type: 'HelsenorgeHttpError',
                    message: error.message,
                    statusCode: error.statusCode,
                    correlationId: error.correlationId,
                    response: error.response,
                },
            };
        }
        if (error instanceof Error) {
            return {
                error: {
                    name: error.name,
                    message: error.message,
                    stack: error.stack,
                },
            };
        }
        return { error: { message: 'Teknisk feil' } };
    }
};
